<form [formGroup]="form" (ngSubmit)="onSubmit()">
    @if (_item && _status !== undefined && _isWaitingForInput !== undefined) {
        @if (_isWaitingForInput) {
            <p-message severity="warn" icon="pi pi-exclamation-triangle"
                ><div class="hcol-flex space-around-center">
                    <div>SR is waiting for input</div>
                </div>
            </p-message>
        } @else {
            @switch (_status) {
                @case (ECpmCTaskStatusApiEnum.READY) {
                    <p-message severity="success" icon="pi pi-check"
                        ><div class="hcol-flex space-around-center">
                            <div>SR is ready</div>
                        </div>
                    </p-message>
                }
                @case (ECpmCTaskStatusApiEnum.IN_PROGRESS) {
                    <p-message severity="info" icon="pi pi-spinner pi-spin"
                        ><div class="hcol-flex space-around-center">
                            <div>SR is in progress</div>
                            <div style="width: 10rem">
                                <app-service-request-progress-data-cell-display
                                    displayType="table"
                                    [row]="_item"
                                ></app-service-request-progress-data-cell-display>
                            </div>
                        </div>
                    </p-message>
                }
                @case (ECpmCTaskStatusApiEnum.FAILED) {
                    <p-message severity="error" icon="pi pi-times"
                        ><div class="hcol-flex space-around-center">
                            <div>SR has failed</div>
                        </div>
                    </p-message>
                }
                @case (ECpmCTaskStatusApiEnum.SUCCESS) {
                    <p-message severity="success" icon="pi pi-check"
                        ><div class="hcol-flex space-around-center">
                            <div>SR has succeeded</div>
                        </div>
                    </p-message>
                }
            }
        }
    }
    <app-ibase-cru-modal-content [showDefaultFormFooter]="true">
        <div class="hcol-flex">
            <div class="floatingLabelContainer" [class.hcol-50]="isCreationMode" [class.hcol-100]="!isCreationMode">
                <p-floatlabel variant="on">
                    <p-select
                        [options]="_serviceRequestGroups"
                        formControlName="service_request_group_uuid"
                        optionLabel="name"
                        optionValue="uuid"
                        inputId="service_request_group_uuid"
                        id="service_request_group_uuid"
                        appendTo="body"
                        [showClear]="true"
                    ></p-select>
                    <label for="service_request_group_uuid">Service Request Group</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <p-select
                        [options]="_projects"
                        formControlName="project_uuid"
                        optionLabel="name"
                        optionValue="uuid"
                        inputId="project_uuid"
                        id="project_uuid"
                        appendTo="body"
                        [showClear]="true"
                    ></p-select>
                    <label for="project_uuid">Project</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <p-select
                        [options]="_organizations"
                        formControlName="organization_uuid"
                        optionLabel="name"
                        optionValue="uuid"
                        inputId="organization_uuid"
                        id="organization_uuid"
                        appendTo="body"
                        [showClear]="true"
                    ></p-select>
                    <label for="organization_uuid">Organization</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <p-treeSelect
                        formControlName="location"
                        id="location"
                        containerStyleClass="width-form"
                        [options]="_locationTreeRoot.children"
                        title="Select a location for this service request"
                        emptyMessage="No location found"
                        [filter]="true"
                        [filterInputAutoFocus]="true"
                        selectionMode="single"
                        [showClear]="true"
                        appendTo="body"
                        [virtualScroll]="true"
                        [virtualScrollItemSize]="35"
                        [virtualScrollOptions]="{scrollHeight: '20rem'}"
                    ></p-treeSelect>
                    <label for="location">Location</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                    <textarea
                        id="description"
                        rows="5"
                        cols="30"
                        pInputTextarea
                        formControlName="description"
                    ></textarea>
                    <label for="description">Description</label>
                </p-floatlabel>
            </div>

            @if (isCreationMode) {
                <div class="hcol-50 floatingLabelContainer">
                    <p-floatlabel variant="on">
                        <p-treeSelect
                            formControlName="function"
                            containerStyleClass="width-form"
                            [options]="_functionsTree"
                            title="Select a function for this task"
                            emptyMessage="No function found"
                            [filter]="true"
                            [filterInputAutoFocus]="true"
                            selectionMode="single"
                            [showClear]="true"
                            appendTo="body"
                            [virtualScroll]="true"
                            [virtualScrollItemSize]="35"
                            [virtualScrollOptions]="{scrollHeight: '20rem'}"
                            pTooltip="Select an optional function to generate task(s)"
                        ></p-treeSelect>
                        <label for="function">Service Request Generator Function</label>
                    </p-floatlabel>

                    <app-action-jobs-function-io-editor
                        side="input"
                        [overrideHeader]="'Generator Parameter(s)'"
                        [plugin]="_selectedPlugin"
                        [pluginFunction]="_selectedPluginFunction"
                        [iosMapping]="_inputsMappings"
                        [objectStoreEntriesTransientCache]="_objectStoreEntriesTransientCache"
                        (validityChangedEvent)="_inputsMappingValid = $event"
                    ></app-action-jobs-function-io-editor>
                </div>
            }
        </div>
    </app-ibase-cru-modal-content>
</form>
